import React, { useEffect, useState, useRef } from "react";
import filterConfig from "./components/filtersConfig";
import {
  CircularProgress,
  IconButton,
  Box,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LeftContainerFilters from "./components/LeftContainerFilters";
import formatDate from "../components/formatDate";
import { useNavigate } from "react-router-dom";
import LeakIcon from "./components/LeakIcon";

const LeakLeftContainer = ({
  leakData,
  leakSelected,
  onLeakSelected,
  onApplyFilters,
  onDrawingToggle,
  isDrawing,
  setCustomAOI,
  setFilterCleared,
  isLoading,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const leakRefs = useRef({});

  useEffect(() => {
    const savedFilters = JSON.parse(sessionStorage.getItem("currentFilters"));
    if (savedFilters) {
      onApplyFilters(savedFilters, false);
    }
  }, []);

  useEffect(() => {
    if (leakSelected && leakRefs.current[leakSelected.id]) {
      leakRefs.current[leakSelected.id].scrollIntoView();
    }
  }, [leakSelected]);

  const handleLeakSelection = (leak) => {
    let prevFilters = JSON.parse(sessionStorage.getItem("selectedFilters"));
    let newFilters = { ...prevFilters, leak: leak };

    sessionStorage.setItem("selectedFilters", JSON.stringify(newFilters)); //
    onLeakSelected(leak);
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const applyFilters = async (filter, clear) => {
    sessionStorage.setItem("currentFilters", JSON.stringify(filter));
    onApplyFilters(filter, clear);
  };

  const onGoLeakClicked = (leakId) => {
    navigate("/observations/" + leakId);
  };

  return (
    <Box
      className={`leak-left-container ${collapsed ? "collapsed" : ""}`}
    >
      <Box className="leak-container">
        <IconButton
          className="collapse-button"
          onClick={toggleCollapse}
          sx={{
            position: "absolute",
            right: "-13px",
            "&:hover": {
              background: "none",
            },
          }}
        >
          {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>
      <Box className="leak-left-container-inner">
        <LeftContainerFilters
          onApplyFilters={applyFilters}
          filterConfig={filterConfig}
          onDrawingToggle={onDrawingToggle}
          isDrawing={isDrawing}
          setCustomAOI={setCustomAOI}
          setFilterCleared={setFilterCleared}
        />
        <Box
          className="leak-left"
          sx={{ alignItems: "center", paddingLeft: "1px" }}
        >
          {isLoading ? (
            <CircularProgress />
          ) : (
            <>
              {leakData && leakData.length > 0 ? (
                leakData.map((data) => (
                  <Paper
                    key={data.identifier}
                    ref={(el) => (leakRefs.current[data.id] = el)}
                    className={`leak-card ${
                      data.id === leakSelected.id ? "selected-card" : ""
                    }`}
                    onClick={() => handleLeakSelection(data)}
                    sx={{ position: "relative" }}
                  >
                    <Box className="leaks-left-upper">
                      <Typography
                        className="leak-detail-text"
                        sx={{
                          fontWeight: "var(--font-bold)",
                          fontSize: "14px",
                          color: theme.palette.primary.main,
                        }}
                      >
                        {data.identifier}
                      </Typography>
                      <LeakIcon
                        status={data.leak_status}
                        severity={data.leak_severity}
                      />
                    </Box>
                    <Box
                      className={`leak-date-container ${
                        data.id === leakSelected.id ? "selected-card" : ""
                      }`}
                    >
                      <Box className="leak-date-container-inner">
                        <Typography className="leak-detail-text-label">
                          {formatDate(data.start_date)}
                        </Typography>
                        <Box className="date-line-2" />
                        <Typography className="leak-detail-text-label">
                          {data.end_date
                            ? formatDate(data.end_date)
                            : "Currently active"}
                        </Typography>
                      </Box>
                    </Box>
                    <VisibilityIcon
                      sx={{
                        position: "absolute",
                        right: "0px",
                        top: "0px",
                        cursor: "pointer",
                        width: "1.5em",
                        height: "0.9em",
                      }}
                      className={`go-leak-button ${
                        data.id === leakSelected.id ? "selected-card" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        onGoLeakClicked(data.id);
                      }}
                    />
                  </Paper>
                ))
              ) : (
                <Box className="no-results" sx={{ width: "90%" }}>
                  No results
                </Box>
              )}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default LeakLeftContainer;
